module.exports = __webpack_public_path__ + "img/c.623f8181.png";